export const MIN_COMPETITORS = 2;
export const MAX_COMPETITORS = 3;
export const MAX_COMPANY_NAME_LENGTH = 255;
/** Runs take minutes up to two hours; the backend suggests re-checking every 30–60 s. */
export const POLL_INTERVAL_MS = 45_000;

const BASE_ROUTE = "/account/social-listing-agent";

export const SOCIAL_LISTENING_ROUTES = {
  home: BASE_ROUTE,
  brandAnalysis: `${BASE_ROUTE}/brand-analysis`,
  competitiveAnalysis: `${BASE_ROUTE}/competitive-analysis`,
  loader: `${BASE_ROUTE}/loader`,
  history: `${BASE_ROUTE}/history`,
  report: (runId: number | string) => `${BASE_ROUTE}/${runId}`,
} as const;

export const getStoredId = (key: "user_id" | "tenant_id"): number | null => {
  const raw = localStorage.getItem(key);
  if (raw === null) {return null;}
  const value = Number(raw);
  return Number.isNaN(value) ? null : value;
};
